<template>
  <div class="line-item">
    <div class="item-title-bar">
      <div class="divider-line divider-line-start"></div>
      <div class="line-item-index">{{ info.status === 3 ? 4 : 3 }}</div>
      <div class="line-item-name">处理完成 {{ info.appeal === '0' ? '不申诉' : '申诉' }}</div>
      <div class="divider-line divider-line-center"></div>
      <div class="line-item-time" v-if="info.officialAccountReportTime">
        处置时间: {{ info.officialAccountReportTime }}
        <i class="el-icon-caret-top"></i>
      </div>
    </div>
    <div class="line-content">
      <ClipBox class="clip-box person-info-wrapper">
        <div class="person-info-box">
          <div class="person-info">
            <div class="info-item">
              <div style="color: #00B2FF;font-size: 18px;font-weight: bold">处理结果</div>
              <div class="cell-label scroll-y" style="height: 130px">{{ info.processResult }}</div>
            </div>
          </div>
        </div>
      </ClipBox>
      <ClipBox class="clip-box" v-show="info.processImg" v-for="img in info.processImg.split(',')" :key="img">
        <el-image
          style="width: 100%; height: 100%;"
          :src="img"
          :preview-src-list="info.processImg.split(',')"
          fit="cover"></el-image>
      </ClipBox>
      <ClipBox class="clip-box person-info-wrapper" v-if="info.appeal === '1' && info.appealType">
        <div class="person-info-box">
          <div class="person-info">
            <div class="info-item">
              <div style="color: #00B2FF;font-size: 18px;font-weight: bold">申诉详情</div>
              <div class="cell-label" v-if="info.appealType">申诉类型：{{ info.appealType }}</div>
              <div class="cell-label" v-if="info.appealType === '其他乡镇'">正确乡镇：{{ info.correctTown }}</div>
              <div class="cell-label" v-if="info.appealType === '其他乡镇'">是否扑灭：{{ info.extinguish == 0 ? '否' : '是' }}</div>
              <div class="cell-label">申诉描述：{{ info.appealDescribe || 无 }}</div>
            </div>
          </div>
        </div>
      </ClipBox>
    </div>
  </div>
</template>

<script>
import ClipBox from "@/components/ClipBox";
export default {
  name: "LineItem", // 报警结束状态时
  components: { ClipBox },
  props: {
    title: { type: Object, default: () => { return {number: 1, title: '平台上报'} } },
    info: { type: Object, default: () => {} }
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
.line-item {
  .item-title-bar {
    display: flex;
    align-items: center;
    margin-top: 12px;
    .btn{
      width: 140px;
      height: 50px;
      background-size: 100% 100%;
      text-align: center;
      line-height: 50px;
      font-size: 18px;
      cursor: pointer;
    }
    .box2{
      background-image: url("../../../../assets/img/box2.png");
      color: #00FFF6;
    }
    .box4{
      background-image: url("../../../../assets/img/box4.png");
      color: #00B2FF;
    }
    .line-item-index {
      position: relative;
      width: 38px;
      height: 31px;
      margin: 0 10px 0 3px;
      font-weight: bold;
      font-style: italic;
      font-size: 20px;
      color: #00b2ff;
      text-align: center;
      line-height: 31px;
      border-radius: 4px;
      box-shadow: 0 0 12px 4px rgba(0, 178, 255, 0.5) inset;

      &::after {
        position: absolute;
        top: 50%;
        right: 0;
        transform: translate(100%, -50%);
        content: "";
        border: 4px solid transparent;
        border-left-color: rgba(0, 178, 255, 0.4);
      }
    }

    .line-item-name {
      margin-right: 6px;
      font-size: 18px;
      color: #ffffff;
    }

    .line-item-time {
      display: flex;
      align-items: center;
      margin-left: 10px;
      font-size: 14px;
      color: #00b2ff;

      .el-icon-caret-top {
        font-size: 22px;
        margin-left: 5px;
      }
    }
  }

  .divider-line {
    border-bottom: 1px dashed #00fff6;

    &.divider-line-start {
      width: 50px;
    }

    &.divider-line-center {
      width: 0;
      flex: auto;
    }
  }

  .line-content {
    display: flex;
    flex-wrap: wrap;

    .clip-box {
      width: 373px;
      height: 182px;
      margin-top: 20px;
      margin-left: 40px;
    }

    .person-info-wrapper {
      .person-info-box {
        width: 100%;
        height: 100%;
        display: flex;

        .person-img {
          width: 190px;
          height: 100%;
          object-fit: cover;
        }

        .person-info {
          width: 0;
          height: 100%;
          flex: auto;
          padding: 8px 10px;
          box-sizing: border-box;

          .info-item {
            line-height: 26px;
            margin-bottom: 4px;
            .info-item-label {
              color: #00b2ff;
              font-size: 14px;
            }

            .info-item-cell {
              display: flex;
              color: #ffffff;
              font-size: 14px;
              .cell-label {
                width: 52px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
